"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const forms_1 = require("@rebass/forms");
const rebass_1 = require("rebass");
const styled_components_1 = __importDefault(require("styled-components"));
function default_1(_a) {
    var { label, value, onChange = () => { }, prefix, error } = _a, rest = __rest(_a, ["label", "value", "onChange", "prefix", "error"]);
    return (react_1.default.createElement(rebass_1.Box, { className: "form-element", mb: 2 },
        react_1.default.createElement(rebass_1.Text, { fontWeight: 500, fontSize: 13, color: rest.disabled ? "#aaa" : undefined }, label),
        react_1.default.createElement(Relative, null,
            react_1.default.createElement(Absolute, null, prefix),
            react_1.default.createElement(forms_1.Input, Object.assign({}, rest, { value: value, onChange: onChange, pl: prefix ? 40 : 15, mt: 2, css: {}, className: error ? 'error' : "" }))),
        react_1.default.createElement(Error, null, error)));
}
exports.default = default_1;
const Relative = styled_components_1.default.div({
    position: "relative",
});
const Absolute = styled_components_1.default.div({
    position: "absolute",
    left: 0,
    bottom: 0,
    width: 40,
    top: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
});
const Error = styled_components_1.default.div `
    color: red;
    font-size: 12px;
    font-weight: 500;
`;
//# sourceMappingURL=TextInput.js.map